import styled from 'styled-components';
import { CarouselMixin } from '../../mixins/components/CarouselMixin';
export var StyledCarousel = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledCarousel",
  componentId: "c11n-8-111-1__sc-ibkoes-0"
})(["", ""], CarouselMixin);